import React, { Component } from "react";

class SetupScreen extends Component {
  render() {
    return <h1>Setup</h1>;
  }
}

export default SetupScreen;
